<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "WrapperSubpages",
  components: {}
};
</script>
<style>
.subpageEnd {
  margin-bottom: calc(var(--LINE-HEIGHT) * 5);
  min-height: calc(var(--LINE-HEIGHT) * 3);
  position: relative;
  width: 100%;
}

.subpageEnd-mail {
  position: absolute;
  vertical-align: top;
  z-index: 10;
  line-height: calc(var(--LINE-HEIGHT) * 2);
  font-size: 20px;
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  display: inline-block;
  left: calc(4 * var(--COLUMN-SIZE));
  bottom: calc(var(--LINE-HEIGHT) * 1);
  transition: var(--TRANSITION);
  text-decoration: underline;
}

.subpageEnd-mail:hover {
  display: inline-block;
  text-decoration-thickness: 2.5px;
}

@media only screen and (max-width: 576px) {
  .subpageEnd-mail {
    left: auto;
    right: auto;
    bottom: -25px;
    position: relative;
    font-size: 18px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    line-height: calc(var(--LINE-HEIGHT) * 2);
  }
  .subpageEnd-mail:after {
    content: " ";
    position: absolute;

    height: 1px;
    background-color: var(--BLACK);
    top: 0;
    left: calc(var(--SPACE-LEFT) * -1);
    right: calc(var(--SPACE-RIGHT) * -1);
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .subpageEnd-mail {
    left: auto;
    right: auto;
    bottom: -25px;
    position: relative;
    font-size: 18px;
    width: 100%;
    text-align: left;
    line-height: calc(var(--LINE-HEIGHT) * 2);
  }
  .subpageEnd-mail:after {
    content: " ";
    position: absolute;

    height: 1px;
    background-color: var(--BLACK);
    top: 0;
    left: calc(var(--SPACE-LEFT) * -1);
    right: calc(var(--SPACE-RIGHT) * -1);
  }
}

@media only screen and (max-width: 576px) {
  .grid-column.forSubPages {
    width: calc(var(--COLUMN-SIZE) * 4);
    padding-right: 0;
    padding-left: 0;
    margin-left: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .grid-column.forSubPages {
    width: calc(var(--COLUMN-SIZE) * 4);
    padding-right: 50px;
    padding-left: 0;
    margin-left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .grid-column.forSubPages {
    width: calc(var(--COLUMN-SIZE) * 5);
    padding-right: 25px;
    padding-left: 0;
    margin-left: calc(var(--COLUMN-SIZE) * 2);
  }
}
@media only screen and (min-width: 992px) {
  .grid-column.forSubPages {
    width: calc(var(--COLUMN-SIZE) * 4);
    padding-right: 25px;
    padding-left: 0;
    margin-left: calc(var(--COLUMN-SIZE) * 2);
  }
}

.title {
  padding-top: var(--LINE-HEIGHT);
  padding-bottom: calc(var(--LINE-HEIGHT) * 1);
}

@media only screen and (max-width: 576px) {
  .title {
    padding-top: calc(var(--LINE-HEIGHT) * 1);
    padding-bottom: calc(var(--LINE-HEIGHT) * 1);
  }

  .title h2 {
    font-size: 40px !important;
    line-height: 40px !important;
    padding-bottom: calc(var(--LINE-HEIGHT) * 2);
    margin: 0;
  }
  .title p {
    margin: 0;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .title {
    padding-bottom: calc(var(--LINE-HEIGHT) * 2);
  }
  .title h2 {
    text-indent: 0 !important;
    font-size: 50px !important;
    margin-bottom: var(--SPACE-BOTTOM-x1);
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .title h2 {
    font-size: 50px !important;
    margin-bottom: var(--SPACE-BOTTOM-x1);
  }
}

@media only screen and (min-width: 992px) {
  .title h2 {
    font-size: 50px !important;
    margin-bottom: var(--SPACE-BOTTOM-x1);
  }
}

.title p {
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.75px;
}

@media only screen and (max-width: 576px) {
  .items {
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.75px;
  }
}

.contentForSubPages {
  padding-right: 25px;
}
@media only screen and (max-width: 576px) {
  .contentForSubPages {
    padding-right: 0;
  }
}

.contentForSubPages p {
  font-size: 18px;
  padding-bottom: calc(var(--LINE-HEIGHT) * 1);
}
.contentForSubPages h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0;
  padding-bottom: calc(var(--LINE-HEIGHT) * 1);
}

.contentForSubPages img {
  width: calc(100% + 212px);

  box-sizing: border-box;
  height: auto;
  min-height: 20vh;

  margin-bottom: var(--LINE-HEIGHT);
  margin-left: -212px;
}

@media only screen and (max-width: 576px) {
  .contentForSubPages img {
    width: 100%;
    margin-left: 0;
    border: 0;
    min-height: calc(20 * var(--vh));
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .contentForSubPages img {
    width: 100%;
    margin-left: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .contentForSubPages img {
    width: calc(100% + 184px);
    margin-left: -184px;
  }
}
@media only screen and (min-width: 992px) {
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/WrapperSubpages.vue